import gql from 'graphql-tag';

export const OpenDispatch = gql`
  mutation openDispatch($dispatchContents: OpenDispatchInput!) {
    openDispatch(dispatchContents: $dispatchContents) {
      dispatchId
    }
  }
`;
